import { render } from "./NewPattyChat.vue?vue&type=template&id=3a1f6f64&scoped=true"
import script from "./NewPattyChat.vue?vue&type=script&lang=js"
export * from "./NewPattyChat.vue?vue&type=script&lang=js"

import "./NewPattyChat.vue?vue&type=style&index=0&id=3a1f6f64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1f6f64"]])

export default __exports__